// extracted by mini-css-extract-plugin
export default {"chart":"Bar_chart__F0lVj"};